import React from 'react';

import PropTypes from 'prop-types';

import {
    StarRating,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import { getRatingLabel } from '../../../utils';

import styles from './OverviewSection.scss';

function RatingsRow(props) {
    const {
        i18nNumber,
        category,
        rating,
    } = props;

    if (!rating) {
        return null;
    }

    const ratingLabel = getRatingLabel(rating);
    const localizedRatingLabel = i18nNumber(ratingLabel)
        .format('decimal', { maximumFractionDigits: 1, minimumFractionDigits: 1 });

    return (
        <TableRow>
            <Typography
                component={TableCell}
                componentProps={{
                    size: 'small',
                    variant: 'head',
                }}
            >
                {category}
            </Typography>
            <TableCell
                className={styles.tableBody}
                size="small"
            >
                <StarRating
                    className={styles.starRating}
                    hoverEffects="none"
                    id={`${category}-rating`}
                    rating={rating - 1}
                    starClassNames={{
                        base: styles.stars,
                        isSelected: styles.starIsSelected,
                    }}
                />
                <Typography>
                    {localizedRatingLabel}
                </Typography>
            </TableCell>
        </TableRow>
    );
}

RatingsRow.propTypes = {
    category: PropTypes.string.isRequired,
    i18nNumber: PropTypes.func.isRequired,
    rating: PropTypes.number.isRequired,
};

const LocalizedRatingsRow = localize(RatingsRow);

function OverviewSection(props) {
    const {
        namespace,
        stats,
        t,
    } = props;
    const {
        reviewCarrierClean,
        reviewCarrierOnTime,
        reviewCarrierSeat,
        reviewCarrierStaff,
        reviewCarrierValue,
    } = stats;

    const ratings = [
        {
            categoryKey: 'travelReviewCommonSeat',
            rating: reviewCarrierSeat,
        },
        {
            categoryKey: 'travelReviewCommonTimeliness',
            rating: reviewCarrierOnTime,
        },
        {
            categoryKey: 'travelReviewCommonStaff',
            rating: reviewCarrierStaff,
        },
        {
            categoryKey: 'travelReviewCommonValue',
            rating: reviewCarrierValue,
        },
        {
            categoryKey: 'travelReviewCommonCondition',
            rating: reviewCarrierClean,
        },
    ];

    return (
        <div className={styles.overview}>
            <Table
                orientation="horizontal"
                variant="blocks"
            >
                <TableBody>
                    {ratings.map(({ categoryKey, rating }) => (
                        <LocalizedRatingsRow
                            category={t(`${namespace}:${categoryKey}`)}
                            key={categoryKey}
                            rating={rating}
                        />
                    ))}
                </TableBody>
            </Table>
        </div>
    );
}

OverviewSection.propTypes = {
    namespace: PropTypes.string.isRequired,
    stats: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export {
    OverviewSection,
    RatingsRow,
};
export default localize(OverviewSection);
